import { render, staticRenderFns } from "./nitroalkane.vue?vue&type=template&id=6f37fcf2&"
import script from "./nitroalkane.vue?vue&type=script&lang=js&"
export * from "./nitroalkane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports